/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.RequiredDocuments";
        const GROUP_CLASS = "reqs-group";
        const DOCTYPE_CLASS = "reqs-doctype";
        const DOCUMENT_CLASS = "reqs-document";
        const REQS_MET_CLASS = "reqs-met";
        const REQS_NOTMET_CLASS = "reqs-not-met";
        const INFO_CLASS = "reqs-info-button";
        const UPLOAD_CLASS = "reqs-upload-button";
        const DELETE_CLASS = "reqs-delete-doc-button";
        const REPLACE_CLASS = "reqs-replace-doc-button";
        const GROUP_STATUS_CLASS = "reqs-group-status";
        const DOCTYPE_STATUS_CLASS = "reqs-doctype-status";
        const COMPLIANT_CLASS = "reqs-status-met";
        const NONCOMPLIANT_CLASS = "reqs-status-not-met";
        const IRRELEVANT_CLASS = "reqs-status-irrelevant";
        const THRESHOLD_HEIGHT = 50;
        class RequiredDocumentsWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("RequiredDocumentsWidgetTypeClass.createInstance()");
                    return new RequiredDocumentsWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("RequiredDocumentsWidgetTypeClass._storeHtml()");
                    RequiredDocumentsWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("RequiredDocumentsWidgetTypeClass::constructor");
                if (RequiredDocumentsWidgetInstanceClass.HtmlData != null) {
                    // make async call in order to get the instances created first
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    if (RequiredDocumentsWidgetInstanceClass.HtmlData == null) {
                        core.Loader.getVersionedHTML('widgets/RequiredDocuments/required-documents.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                    }
                }
            }
        }
        Widgets.RequiredDocumentsWidgetTypeClass = RequiredDocumentsWidgetTypeClass;
        class RequiredDocumentsWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._typedConfig = null;
                this._instanceSelector = null;
                this._loader = null;
                this._refreshButton = null;
                this._noProfileBanner = null;
                this._subheader = null;
                this._subheaderText = null;
                this._reqsMetTranslation = "Requirements Met";
                this._reqsNotMetTranslation = "Requirements Not Met";
                this._lockedModeTranslation = "Review Documents";
                this._fileInput = null;
                this._groupListHolder = null;
                this._dataList = null;
                this._keywordsDiv = null;
                this._keywordsSubwidget = null;
                this._keywordsHeading = null;
                this._keywordsFooter = null;
                this._keywordsHolder = null;
                this._kwComponent = null;
                this._kwCompRequest = null;
                this._usesMaxHeight = null;
                this._maxHeightPx = null;
                this._resizeObserver = null;
                this._mainContentDiv = null;
                this._selectUploadedDocs = true;
                this._replaceDocEnabled = false;
                this._deleteDocEnabled = true;
                this._refreshEnabled = false;
                this._deleteNotifications = true;
                this._deleteFormTemplate = null;
                this._allowInheritedOverride = false;
                this._lockKeywordTypeName = null;
                this._interfaceLocked = false;
                this._replaceDocInProgress = null;
                this._replaceDeleteProcessed = false;
                this._replaceUploadProcessed = false;
                this._confirmDeletions = true;
                this._confirmReplacements = true;
                this._acceptFilter = null;
                this._allowDocDateInput = false;
                this._showBusyModal = true;
                this._busyModalSession = null;
                this._uniqueIdKeywordName = "WPT Transaction ID";
                this._uniqueId = null;
                this._applyContexts = [];
                this._contextKeyword = null;
                this._activeDocument = null;
                this._activeDocType = null;
                this._activeProfile = null;
                this._currentHitList = {};
                this._oldHitList = [];
                this._oldHitListTypeMap = {};
                this._filesToProcess = 0;
                this._compliantStyles = ['wpt-font-icon_TickBold'];
                this._nonCompliantStyles = ['wpt-font-error'];
                this._irrelevantStyles = ['wpt-font-fiber_manual_record'];
                this._uploadButtonStyles = ['wpt-font-file_upload'];
                this._deleteButtonStyles = ['wpt-font-icon_DeleteDoc'];
                this._replaceButtonStyles = ['wpt-font-upload_file'];
                this._infoButtonStyles = ['wpt-font-icon_Info'];
                this._suppressStatusIcons = false;
                this._suppressStatusBanner = false;
                this._suppressCountBadges = false;
                this._staticMode = false;
                // Additions to support 
                this._duplicateSeparator = ">>";
                this._typeMapToHandle = null;
                this._typeMapFromHandle = null;
                this._typeMapCounter = 1;
                this._activeRequirement = null;
                this._currentListData = null;
                this._activateIntoSlots = [WPTNamespace.Utilities.RELATED_SLOT_KEY];
                this._reactToSlots = [WPTNamespace.Utilities.PRIMARY_SLOT_KEY];
                this._lastReactedSlots = [];
                this.presentInstance = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = RequiredDocumentsWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._usesMaxHeight = false;
                    this._maxHeightPx = -1;
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._refreshButton = this._container.querySelector('#requiredDocsRefresh');
                    this._subheader = this._container.querySelector('#requiredDocsSubheader');
                    this._subheaderText = this._subheader.querySelector('#requiredDocsSubheaderText');
                    this._fileInput = this._container.querySelector('#requiredDocsFileInput');
                    this._mainContentDiv = this._container.querySelector('#requiredDocsMainContent');
                    this._groupListHolder = this._container.querySelector('#requiredDocsGroupList');
                    this._noProfileBanner = this._container.querySelector('#reqDocsNoRequirements');
                    this._keywordsDiv = this._container.querySelector('#requiredDocsKeywordsPlaceHolder');
                    this._keywordsSubwidget = this._keywordsDiv.querySelector('#rdKeywordsSubwidget');
                    this._keywordsHeading = this._keywordsDiv.querySelector('#rdKeywordsHeading');
                    this._keywordsFooter = this._keywordsDiv.querySelector('#rdKeywordsFooter');
                    this._keywordsHolder = this._keywordsDiv.querySelector('#rdKeywordsComponent');
                    let sizeTable = this._container.querySelector('.widget__size-target');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#requiredDocsWidgetTitle'), 'STR_WPT_REQ_DOCS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#requiredDocsKeywordsTitle'), "STR_WPT_KEYWORDS");
                    this._core.Helper.setElementTranslation(this._container.querySelector('#reqDocsNoRequirementsLabel'), "STR_WPT_NO_REQ_DOCS_PROFILE");
                    this._reqsMetTranslation = this._core.Locale.getTranslation("STR_WPT_REQ_DOCS_MET");
                    this._reqsNotMetTranslation = this._core.Locale.getTranslation("STR_WPT_NO_REQ_DOCS_NOTMET");
                    this._lockedModeTranslation = this._core.Locale.getTranslation("STR_WPT_REQ_DOCS_REVIEWBANNER");
                    this._core.Helper.setElementTranslationAttribute(this._refreshButton, 'title', 'STR_WPT_REFRESH');
                    this._refreshButton.addEventListener('click', this._refreshDocumentList);
                    this._fileInput.addEventListener('change', this._fileSelected, false);
                    let maxHeight = window.getComputedStyle(sizeTable).maxHeight;
                    if (maxHeight != "none") {
                        // expecting max-height set in pixels
                        this._maxHeightPx = parseInt(maxHeight, 10);
                        this._usesMaxHeight = true;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using max-height: " + this._maxHeightPx);
                        }
                        if (window.ResizeObserver) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("browser supports ResizeObserver");
                            }
                            this._resizeObserver = new ResizeObserver(this._setKeywordsMaxHeight);
                        }
                        else {
                            console.warn("browser doesn't support ResizeObserver");
                        }
                    }
                    this._core.Functions.showElement(this._loader);
                    this._typedConfig = this._config;
                    if (!this._typedConfig.hasOwnProperty('ServiceDocumentTypes') || (this._typedConfig.ServiceDocumentTypes == null))
                        this._typedConfig.ServiceDocumentTypes = ['*'];
                    if (!this._typedConfig.hasOwnProperty('Keywords') || (this._typedConfig.Keywords == null))
                        this._typedConfig.Keywords = [];
                    if (!this._typedConfig.hasOwnProperty('KeywordGroups') || (this._typedConfig.KeywordGroups == null))
                        this._typedConfig.KeywordGroups = [];
                    if (this._typedConfig.hasOwnProperty('AllowDocDateInput') && this._typedConfig.AllowDocDateInput)
                        this._allowDocDateInput = true;
                    if (!this._typedConfig.hasOwnProperty('InheritKeywords') || (this._typedConfig.InheritKeywords == null))
                        this._typedConfig.InheritKeywords = [];
                    if (!this._typedConfig.hasOwnProperty('InheritKeywordGroups') || (this._typedConfig.InheritKeywordGroups == null))
                        this._typedConfig.InheritKeywordGroups = [];
                    if (!this._typedConfig.hasOwnProperty('LockKeywordValues') || (this._typedConfig.LockKeywordValues == null))
                        this._typedConfig.LockKeywordValues = [];
                    if (this._typedConfig.hasOwnProperty('AcceptFilter') && (this._typedConfig.AcceptFilter))
                        this._acceptFilter = this._typedConfig.AcceptFilter;
                    if (this._typedConfig.hasOwnProperty('CompliantIconStyles') && (this._typedConfig.CompliantIconStyles))
                        this._compliantStyles = this._typedConfig.CompliantIconStyles;
                    if (this._typedConfig.hasOwnProperty('NonCompliantIconStyles') && (this._typedConfig.NonCompliantIconStyles))
                        this._nonCompliantStyles = this._typedConfig.NonCompliantIconStyles;
                    if (this._typedConfig.hasOwnProperty('IrrelevantIconStyles') && (this._typedConfig.IrrelevantIconStyles))
                        this._irrelevantStyles = this._typedConfig.IrrelevantIconStyles;
                    if (this._typedConfig.hasOwnProperty('UploadButtonIconStyles') && (this._typedConfig.UploadButtonIconStyles))
                        this._uploadButtonStyles = this._typedConfig.UploadButtonIconStyles;
                    if (this._typedConfig.hasOwnProperty('DeleteButtonIconStyles') && (this._typedConfig.DeleteButtonIconStyles))
                        this._deleteButtonStyles = this._typedConfig.DeleteButtonIconStyles;
                    if (this._typedConfig.hasOwnProperty('ReplaceButtonIconStyles') && (this._typedConfig.ReplaceButtonIconStyles))
                        this._replaceButtonStyles = this._typedConfig.ReplaceButtonIconStyles;
                    if (this._typedConfig.hasOwnProperty('InfoButtonIconStyles') && (this._typedConfig.InfoButtonIconStyles))
                        this._infoButtonStyles = this._typedConfig.InfoButtonIconStyles;
                    if ((this._typedConfig.hasOwnProperty('UniqueIdKeywordName')) && (this._typedConfig.UniqueIdKeywordName))
                        this._uniqueIdKeywordName = this._typedConfig.UniqueIdKeywordName;
                    if (this._typedConfig.hasOwnProperty('DocEntrySeparator') && (this._typedConfig.DocEntrySeparator))
                        this._duplicateSeparator = this._typedConfig.DocEntrySeparator;
                    if ((this._typedConfig.hasOwnProperty('ApplyContexts')) && (this._typedConfig.ApplyContexts != null))
                        this._applyContexts = this._typedConfig.ApplyContexts;
                    if ((this._typedConfig.hasOwnProperty('MapContextToKeyword')) && this._typedConfig.MapContextToKeyword)
                        this._contextKeyword = this._typedConfig.MapContextToKeyword;
                    if ((this._typedConfig.hasOwnProperty('ReplaceEnabled')) && (this._typedConfig.ReplaceEnabled != null))
                        this._replaceDocEnabled = this._typedConfig.ReplaceEnabled;
                    if ((this._typedConfig.hasOwnProperty('NotifyOnDelete')) && (this._typedConfig.NotifyOnDelete != null))
                        this._deleteNotifications = this._typedConfig.NotifyOnDelete;
                    if ((this._typedConfig.hasOwnProperty('DeleteEnabled')) && (this._typedConfig.DeleteEnabled != null))
                        this._deleteDocEnabled = this._typedConfig.DeleteEnabled;
                    if ((this._typedConfig.hasOwnProperty('ConfirmDeletions')) && (this._typedConfig.ConfirmDeletions != null))
                        this._confirmDeletions = this._typedConfig.ConfirmDeletions;
                    if ((this._typedConfig.hasOwnProperty('ConfirmReplacements')) && (this._typedConfig.ConfirmReplacements != null))
                        this._confirmReplacements = this._typedConfig.ConfirmReplacements;
                    if ((this._typedConfig.hasOwnProperty('RefreshEnabled')) && (this._typedConfig.RefreshEnabled != null))
                        this._refreshEnabled = this._typedConfig.RefreshEnabled;
                    if ((this._typedConfig.hasOwnProperty('SelectUploadedDocs')) && (this._typedConfig.SelectUploadedDocs != null))
                        this._selectUploadedDocs = this._typedConfig.SelectUploadedDocs;
                    if ((this._typedConfig.hasOwnProperty('DeletionEventForm')) && (this._typedConfig.DeletionEventForm != null))
                        this._deleteFormTemplate = this._typedConfig.DeletionEventForm;
                    if ((this._typedConfig.hasOwnProperty('AllowInheritedOverride')) && (this._typedConfig.AllowInheritedOverride != null))
                        this._allowInheritedOverride = this._typedConfig.AllowInheritedOverride;
                    if ((this._typedConfig.hasOwnProperty('LockKeywordType')) && this._typedConfig.LockKeywordType)
                        this._lockKeywordTypeName = this._typedConfig.LockKeywordType;
                    if ((this._typedConfig.hasOwnProperty('SuppressStatusIcons')) && (this._typedConfig.SuppressStatusIcons != null))
                        this._suppressStatusIcons = this._typedConfig.SuppressStatusIcons;
                    if ((this._typedConfig.hasOwnProperty('SuppressStatusBanner')) && (this._typedConfig.SuppressStatusBanner != null))
                        this._suppressStatusBanner = this._typedConfig.SuppressStatusBanner;
                    if ((this._typedConfig.hasOwnProperty('SuppressCountBadges')) && (this._typedConfig.SuppressCountBadges != null))
                        this._suppressCountBadges = this._typedConfig.SuppressCountBadges;
                    if ((this._typedConfig.hasOwnProperty('ShowBusyModal')) && (this._typedConfig.ShowBusyModal != null))
                        this._showBusyModal = this._typedConfig.ShowBusyModal;
                    if ((this._typedConfig.hasOwnProperty('StaticMode')) && (this._typedConfig.StaticMode != null))
                        this._staticMode = this._typedConfig.StaticMode;
                    this._interfaceLocked = this._staticMode;
                    if (this._typedConfig.hasOwnProperty('ActivateIntoSlots') && (this._typedConfig.ActivateIntoSlots != null) && (this._typedConfig.ActivateIntoSlots.length > 0))
                        this._activateIntoSlots = this._typedConfig.ActivateIntoSlots;
                    if (this._typedConfig.hasOwnProperty("ReactToSlots") && (this._typedConfig.ReactToSlots != null))
                        this._reactToSlots = this._typedConfig.ReactToSlots;
                    this._fileInput.accept = this._acceptFilter;
                    if (this._refreshEnabled) {
                        this._core.Functions.showElement(this._refreshButton);
                    }
                    // Filter unique ID keyword out of visible keywords, should never be edited
                    this._typedConfig.Keywords = this._typedConfig.Keywords.filter(k => (k != this._uniqueIdKeywordName));
                    this._kwComponent = new Widgets.ComponentKeywordsUpload(this._core, this._keywordsHolder, this);
                    this._kwComponent.ErrorCallback = this._callErrorHandler;
                    this._kwComponent.FailCallback = this._callFailedHandler;
                    this._kwComponent.NoKeysToDisplayCallback = this._noKeysDisplayed;
                    this._kwComponent.present();
                    let listConfig = {
                        SelectItemCallback: this._docClicked
                    };
                    this._dataList = new Widgets.ComponentDataList(this._core, this._groupListHolder, this, listConfig);
                    this._dataList.present();
                    // We know we'll need the document types, but we have no use for them immediately so no callback
                    this._core.OBHelper.LoadUploadDocumentTypes();
                    this._core.Functions.hideElement(this._loader);
                    this._type.instanceReady(this.getHandle());
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                    if (this._busyModalSession) {
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                };
                this._callFailedHandler = (json) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                    if (this._busyModalSession) {
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                };
                this._replaceDeleteCallErrorHandler = (url, status, message) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._replaceDeleteCallErrorHandler()");
                    this.addError(message);
                    if (this._replaceDocInProgress) {
                        this._replaceDeleteProcessed = true;
                        if (this._replaceUploadProcessed) {
                            this._replaceDocInProgress = null;
                            this._getExistingRelatedDocuments();
                        }
                    }
                    if (this._busyModalSession) {
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                };
                this._replaceDeleteCallFailedHandler = (json) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._replaceDeleteCallFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    if (this._replaceDocInProgress) {
                        this._replaceDeleteProcessed = true;
                        if (this._replaceUploadProcessed) {
                            this._replaceDocInProgress = null;
                            this._getExistingRelatedDocuments();
                        }
                    }
                    if (this._busyModalSession) {
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                };
                this._extractDocTypeName = (nameInput) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._extractDocTypeName()");
                    if (!nameInput.startsWith(this._duplicateSeparator))
                        return nameInput;
                    let chunks = nameInput.split(this._duplicateSeparator);
                    if (chunks.length > 1)
                        return chunks[1];
                    else
                        return nameInput;
                };
                this._extractDuplicateKeyName = (nameInput) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._extractDuplicateKeyName()");
                    if (!nameInput.startsWith(this._duplicateSeparator))
                        return nameInput;
                    let chunks = nameInput.split(this._duplicateSeparator);
                    if (chunks.length > 2)
                        return chunks[2];
                    else
                        return nameInput;
                };
                this._extractDuplicateKeyValue = (nameInput) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._extractDuplicateKeyValue()");
                    if (!nameInput.startsWith(this._duplicateSeparator))
                        return nameInput;
                    let chunks = nameInput.split(this._duplicateSeparator);
                    if (chunks.length > 3)
                        return chunks[3];
                    else
                        return nameInput;
                };
                this._prePresentUploadDocTypes = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._prePresentUploadDocTypes()");
                    this._core.OBHelper.LoadUploadDocumentTypes(this._presentUploadDocTypes);
                };
                this._presentUploadDocTypes = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._presentUploadDocTypes()");
                    if (!this._activeProfile)
                        return;
                    this._dataList.clearList();
                    this._core.Functions.hideElement(this._loader);
                    this._core.Functions.hideElement(this._subheader);
                    this._typeMapToHandle = {};
                    this._typeMapFromHandle = {};
                    this._currentHitList = {};
                    this._oldHitList = [];
                    this._oldHitListTypeMap = {};
                    let uploadDocCount = 0;
                    this._currentListData = {
                        Items: []
                    };
                    // Every group gets a block in the UI - we want to sort by group ID
                    let groupNames = [];
                    this._activeProfile.Groups.forEach(grp => { groupNames.push(grp.Id); });
                    groupNames.sort();
                    groupNames.forEach(groupName => {
                        uploadDocCount = uploadDocCount + this._presentGroup(this._activeProfile.Groups.find(grp => (grp.Id == groupName)));
                    });
                    this._dataList.displayData(this._currentListData);
                    this._core.OBHelper.LoadKeywordTypes(this._presentKeywords);
                    // calculate max-height for keywords if necessary
                    if (this._usesMaxHeight) {
                        this._setKeywordsMaxHeight();
                        if (this._resizeObserver) {
                            this._resizeObserver.observe(this._groupListHolder);
                            this._resizeObserver.observe(this._keywordsDiv);
                            this._resizeObserver.observe(this._keywordsSubwidget);
                            this._resizeObserver.observe(this._keywordsHeading);
                            this._resizeObserver.observe(this._keywordsFooter);
                        }
                    }
                    if (uploadDocCount > 0) {
                        this._core.Functions.hideElement(this._noProfileBanner);
                        this._core.Functions.showElement(this._mainContentDiv);
                        this._getExistingRelatedDocuments();
                    }
                };
                // Build a group container 
                this._presentGroup = (groupDef) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._presentGroup()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`presenting group: ${groupDef.Id}`);
                    }
                    let itemData = {
                        Id: groupDef.Id,
                        AdditionalClasses: [GROUP_CLASS],
                        Items: []
                    };
                    this._currentListData.Items.push(itemData);
                    let label = (groupDef.Label) ? groupDef.Label : 'STR_WPT_RD_DEFAULT_GROUP_LABEL';
                    itemData.DisplayName = this._core.Locale.getTranslation(label);
                    // Now create info button if necessary
                    if (this._hasGroupInfo(groupDef)) {
                        if (!itemData.SuffixIcons) {
                            itemData.SuffixIcons = [];
                        }
                        let icon = {
                            Classes: [INFO_CLASS, ...this._infoButtonStyles],
                            Callback: this._infoClicked
                        };
                        itemData.SuffixIcons.push(icon);
                    }
                    return this._presentDocTypesForGroup(groupDef.Requirements, itemData);
                };
                //private _presentDocTypesForGroup = (docTypeRows: { [typeName: string]: RequiredDocsDocTypeEntry}, groupData: DataListItemData): number => {
                this._presentDocTypesForGroup = (docTypeRows, groupData) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._presentDocTypesForGroup()");
                    let uploadDocTypes = this._core.OBHelper.UploadDocumentTypes;
                    let uploadDocCount = 0;
                    //for(let typeName in docTypeRows) {
                    //let requirement: RequiredDocsDocTypeEntry = docTypeRows[typeName];
                    docTypeRows.forEach(requirement => {
                        let actualName = this._extractDocTypeName(requirement.DocTypeName);
                        // Note: this will return the usual name if there are no duplicate-via-keyword settings in place
                        let visibleName = this._extractDuplicateKeyValue(requirement.DocTypeName);
                        let docType = uploadDocTypes.find(dt => dt.Name == actualName);
                        if (!docType) {
                            this.addError(`Requested document type '${requirement.DocTypeName}' not found`); // TODO: translation
                            return;
                        }
                        // Save our type map
                        this._typeMapCounter++;
                        this._typeMapToHandle[requirement.DocTypeName] = this._typeMapCounter.toString();
                        this._typeMapFromHandle[this._typeMapCounter.toString()] = requirement.DocTypeName;
                        // Need an element for the list
                        let itemData = {
                            Id: docType.Id.toString(10) + "-" + this._typeMapCounter.toString(10),
                            AdditionalClasses: [DOCTYPE_CLASS],
                            DisplayName: this._core.Locale.getTranslation(this._core.OBHelper.getDocTypeAlias(visibleName, docType.TranslatedName)),
                            Items: []
                        };
                        groupData.Items.push(itemData);
                        // Badge for expected count
                        if (!this._suppressCountBadges) {
                            itemData.PrefixBadge = this._createCountLabel(requirement);
                        }
                        // Adding button icons
                        if (!this._interfaceLocked) {
                            if (!itemData.SuffixIcons) {
                                itemData.SuffixIcons = [];
                            }
                            let icon = {
                                Classes: [UPLOAD_CLASS, ...this._uploadButtonStyles],
                                Callback: this._uploadClicked
                            };
                            itemData.SuffixIcons.push(icon);
                        }
                        uploadDocCount++;
                    });
                    return uploadDocCount;
                };
                this._presentKeywords = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._presentKeywords()");
                    // First things first: If we have no configured keywords then don't even show the component
                    if (this._interfaceLocked || !this._typedConfig.hasOwnProperty('Keywords') || (this._typedConfig.Keywords == null) || (this._typedConfig.Keywords.length == 0)) {
                        this._log.trace("no keywords configured or interface locked");
                        this._core.Functions.hideElement(this._keywordsDiv);
                        return;
                    }
                    // We're only going to show keywords requested in the configuration of the widget -
                    // it's up to the installer to figure out whether these are "good" keywords
                    this._kwCompRequest = {
                        IncludeKeywords: [],
                        IncludeGroups: [],
                        DocTypes: Object.keys(this._activeProfile.FlatRequirementMap),
                        PrefillRecords: [],
                        SuppressDocDate: !this._allowDocDateInput
                    };
                    let blockedKeys = [];
                    let blockedGroups = [];
                    this._activeDocument.KeywordRecords.forEach(akwr => {
                        if (akwr.Type != 'MultiInstance') {
                            // SA/SI records get the keyword filter treatment
                            let prefillRecord = JSON.parse(JSON.stringify(akwr));
                            prefillRecord.Keywords = [];
                            for (let kCount = 0; kCount < akwr.Keywords.length; kCount++) {
                                let kInstance = akwr.Keywords[kCount];
                                if (this._typedConfig.Keywords.indexOf(kInstance.Name) > -1) {
                                    if (this._typedConfig.InheritKeywords.indexOf(kInstance.Name) > -1) {
                                        if (this._allowInheritedOverride)
                                            prefillRecord.Keywords.push(kInstance);
                                        else
                                            blockedKeys.push(kInstance.Name);
                                    }
                                }
                            }
                            if (prefillRecord.Keywords.length > 0)
                                this._kwCompRequest.PrefillRecords.push(prefillRecord);
                        }
                        else {
                            // MIKGS managed at the record level
                            if ((this._typedConfig.KeywordGroups.indexOf(akwr.Name) != -1)) {
                                if (this._typedConfig.InheritKeywordGroups.indexOf(akwr.Name) > -1) {
                                    if (this._allowInheritedOverride)
                                        this._kwCompRequest.PrefillRecords.push(akwr);
                                    else
                                        blockedGroups.push(akwr.Name);
                                }
                            }
                        }
                    });
                    // Show all the keywords minus any blocked for inheritance reasons
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Blocked keys: ${blockedKeys}`);
                        this._log.trace(`Blocked groups: ${blockedGroups}`);
                    }
                    this._typedConfig.Keywords.forEach(kwName => {
                        if (blockedKeys.indexOf(kwName) == -1)
                            this._kwCompRequest.IncludeKeywords.push(kwName);
                    });
                    this._typedConfig.KeywordGroups.forEach(grpName => {
                        if (blockedGroups.indexOf(grpName) == -1)
                            this._kwCompRequest.IncludeGroups.push(grpName);
                    });
                    // If we have nothing in the IncludeGroups and IncludeKeywords, it means everything is blocked, so don't show KW editor
                    if ((this._kwCompRequest.IncludeKeywords.length == 0) && (this._kwCompRequest.IncludeGroups.length == 0)) {
                        this._log.trace("all keywords and keyword groups blocked, bypassing kw component.");
                        this._core.Functions.hideElement(this._keywordsDiv);
                        return;
                    }
                    // Display            
                    this._core.Functions.showElement(this._keywordsDiv);
                    this._log.trace('Making keyword component request');
                    this._kwComponent.makeRequest(this._kwCompRequest);
                };
                this._noKeysDisplayed = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._noKeysDisplayed()");
                    this._core.Functions.hideElement(this._keywordsDiv);
                };
                this._createCountLabel = (requirement) => {
                    if ((requirement.Minimum == 0) && (requirement.Maximum == 0))
                        return '*';
                    if ((requirement.Minimum > 0) && (requirement.Maximum == 0))
                        return `${requirement.Minimum}+`;
                    if ((requirement.Minimum == 0) && (requirement.Maximum > 0))
                        return `0-${requirement.Maximum}`;
                    if ((requirement.Minimum > 0) && (requirement.Maximum == requirement.Minimum))
                        return `${requirement.Minimum}`;
                    if ((requirement.Minimum != requirement.Maximum))
                        return `${requirement.Minimum}-${requirement.Maximum}`;
                    // Safety default
                    return '';
                };
                /**
                 * Calculates the according max-height for the keywords, based on the max-height of the widget.
                 */
                this._setKeywordsMaxHeight = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._setKeywordsMaxHeight()");
                    // remove 1px to avoid scroll bars without need
                    let calcMaxHeightPx = this._maxHeightPx - 1;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("starting with keywords height: " + calcMaxHeightPx);
                    }
                    // remove complete height of upload table
                    calcMaxHeightPx -= this._core.Functions.getCompleteElementHeight(this._groupListHolder);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without data list: " + calcMaxHeightPx);
                    }
                    // remove margin height of keywords div
                    calcMaxHeightPx -= this._core.Functions.getElementMarginHeight(this._keywordsDiv);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without margin: " + calcMaxHeightPx);
                    }
                    // remove border height of keywords div
                    calcMaxHeightPx -= this._core.Functions.getElementBorderHeight(this._keywordsDiv);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without border: " + calcMaxHeightPx);
                    }
                    // remove padding height of keywords div
                    calcMaxHeightPx -= this._core.Functions.getElementPaddingHeight(this._keywordsDiv);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without div padding: " + calcMaxHeightPx);
                    }
                    // remove margin height of keywords subwidget
                    calcMaxHeightPx -= this._core.Functions.getElementMarginHeight(this._keywordsSubwidget);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without subwidget margin: " + calcMaxHeightPx);
                    }
                    // remove border height of keywords subwidget
                    calcMaxHeightPx -= this._core.Functions.getElementBorderHeight(this._keywordsSubwidget);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without subwidget border: " + calcMaxHeightPx);
                    }
                    // remove padding height of keywords subwidget
                    calcMaxHeightPx -= this._core.Functions.getElementPaddingHeight(this._keywordsSubwidget);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without subwidget padding: " + calcMaxHeightPx);
                    }
                    // remove complete height of keywords heading
                    calcMaxHeightPx -= this._core.Functions.getCompleteElementHeight(this._keywordsHeading);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without heading: " + calcMaxHeightPx);
                    }
                    // remove complete height of keywords footer
                    calcMaxHeightPx -= this._core.Functions.getCompleteElementHeight(this._keywordsFooter);
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("keywords height without footer: " + calcMaxHeightPx);
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got keywords height: " + calcMaxHeightPx);
                    }
                    if (calcMaxHeightPx > THRESHOLD_HEIGHT) {
                        // set the calculated max-height on the keywords
                        this._keywordsHolder.style.maxHeight = calcMaxHeightPx + "px";
                    }
                    else {
                        this._keywordsHolder.style.removeProperty('max-height');
                    }
                };
                this._infoClicked = (id, event) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._infoClicked()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("info clicked for: " + id);
                    }
                    if (event) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got event");
                        }
                        event.stopPropagation(); // prevent group collapsing
                    }
                    let groupDef = this._activeProfile.Groups.find(grp => (grp.Id == id));
                    this._core.Helper.presentMessageModal(WPTNamespace.ModalType.FIRST, this._compileGroupInfo(groupDef), 'STR_WPT_RD_GROUP_INFO');
                };
                this._uploadClicked = (id, event) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._uploadClicked()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("upload clicked for: " + id);
                    }
                    if (event) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got event");
                        }
                        event.stopPropagation(); // prevent doc type collapsing
                    }
                    let idParts = id.split("-");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("got id parts: " + JSON.stringify(idParts));
                    }
                    let docTypeId = Number(idParts[0]);
                    let mapKey = idParts[1];
                    this._activeRequirement = this._activeProfile.FlatRequirementMap[this._typeMapFromHandle[mapKey]];
                    if (!this._activeRequirement) {
                        this.addError(`Unable to find map definition for doc type with ID ${mapKey}`);
                        return;
                    } // TODO: translation
                    // Clear down any outstanding possibly-cancelled actions
                    this._replaceDocInProgress = null;
                    this._replaceDeleteProcessed = false;
                    this._replaceUploadProcessed = false;
                    // We can't have got this far without the OBHelper already having loaded the doc type list
                    this._activeDocType = this._core.OBHelper.UploadDocumentTypes.find(dtRecord => dtRecord.Id == docTypeId);
                    if (!this._activeDocType) {
                        this.addError(`Unable to find definition for doc type with ID ${docTypeId}`);
                        return;
                    } // TODO: translation
                    // TODO: potentially add accept filter to profile form and apply it on file input before "click"
                    // Workaround for Chrome - if you select the same file twice it doesn't fire onchange, so clear value to force event firing
                    this._fileInput.value = null;
                    // Select a document or documents
                    this._fileInput.click();
                };
                this._fileSelected = (event) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._fileSelected()");
                    if (!this._kwComponent.Valid) {
                        this._core.Helper.presentWarningModal('STR_WPT_REQUIRED_ARCHIVE_KEYS_MISSING');
                        return;
                    }
                    if (!this._fileInput.files) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("no files in list");
                        }
                        this._replaceDocInProgress = null;
                        return;
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`${this._fileInput.files.length} files in list`);
                    }
                    // Replace only allows one file to be selected
                    if (this._replaceDocInProgress && (this._fileInput.files.length > 1)) {
                        this._replaceDocInProgress = null;
                        this._core.Helper.presentWarningModal("STR_WPT_RD_REPLACE_SINGLE_ONLY");
                        return;
                    }
                    // How many docs are we adding? Correct for the fact we might be replacing
                    let incomingCount = this._fileInput.files.length;
                    if (this._replaceDocInProgress)
                        incomingCount--;
                    // Need to ensure we don't go over the maximum number of files allowed for type or group
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Looking for requirement under doc type '${this._activeRequirement.DocTypeName}'`);
                    }
                    let requirement = this._activeProfile.FlatRequirementMap[this._activeRequirement.DocTypeName];
                    if ((requirement.Maximum > 0) && ((requirement.Current + incomingCount) > requirement.Maximum)) {
                        this._core.Helper.presentWarningModal("STR_WPT_RD_TOO_MANY_DOCS_TYPE");
                        this._replaceDocInProgress = null;
                        return;
                    }
                    if (this._log.isTraceEnabled()) {
                        this._log.trace(`Looking for requirement group '${requirement.GroupId}'`);
                    }
                    let groupDef = this._activeProfile.Groups.find(grp => (grp.Id == requirement.GroupId));
                    if ((groupDef.MaxDocs > 0) && ((groupDef.TotalDocs + incomingCount) > groupDef.MaxDocs)) {
                        this._core.Helper.presentWarningModal("STR_WPT_RD_TOO_MANY_DOCS_GROUP");
                        this._replaceDocInProgress = null;
                        return;
                    }
                    // Make two passes - one to determine filter out bad files, then actually attempt uploads
                    let validFiles = [];
                    for (let i = 0; i < this._fileInput.files.length; i++) {
                        let file = this._fileInput.files[i];
                        // Validate the file
                        if (!this._core.Helper.validateFileFormat(file.name.split('.').pop().toUpperCase())) {
                            this._core.Helper.presentWarningModal("STR_WPT_UPLOAD_INVALID_FORMAT");
                            continue;
                        }
                        if (!this._core.Helper.validateFileSize(file.size)) {
                            this._core.Helper.presentWarningModal("STR_WPT_UPLOAD_SIZE_EXCEEDED");
                            continue;
                        }
                        validFiles.push(this._fileInput.files[i]);
                    }
                    // Jump out if all all files invalid
                    if (validFiles.length == 0)
                        return;
                    if (this._showBusyModal) {
                        let modalSession = 'reqdocs-upload-' + performance.now();
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("created modal session: " + modalSession);
                        }
                        if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.FIRST, modalSession, "STR_WPT_PROCESSING")) {
                            this._busyModalSession = modalSession;
                        }
                    }
                    // Special case if we are in a replace loop
                    if (this._replaceDocInProgress) {
                        this._initiateDocReplace(validFiles[0]);
                        return;
                    }
                    // Second pass, actually call the uploader
                    this._filesToProcess = validFiles.length;
                    validFiles.forEach(f => {
                        let requestUpload = {
                            DocType: this._activeDocType.Name,
                            FileType: f.name.split('.').pop().toUpperCase(),
                            KeywordRecords: this._assembleKeywords(),
                            PreventAddToWorkflow: false
                        };
                        let request = JSON.stringify(requestUpload);
                        let formData = new FormData();
                        formData.append("request", request);
                        formData.append('file', f);
                        let headers = {
                            "Content-Type": "multipart/form-data"
                        };
                        this._core.Loader.genericServiceCallWithData('/Upload.svc/rest/MultiPartUploadDocument', formData, this._finishedUpload.bind(this, f.name), headers, this._errorUpload.bind(this, f.name), this._failedUpload.bind(this, f.name));
                    });
                };
                this._initiateDocReplace = (file) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._initiateDocReplace()");
                    let requestUpload = {
                        DocType: this._activeDocType.Name,
                        FileType: file.name.split('.').pop().toUpperCase(),
                        KeywordRecords: this._replaceDocInProgress.KeywordRecords,
                        PreventAddToWorkflow: false
                    };
                    let request = JSON.stringify(requestUpload);
                    let formData = new FormData();
                    formData.append("request", request);
                    formData.append('file', file);
                    let headers = {
                        "Content-Type": "multipart/form-data"
                    };
                    // Call upload
                    this._core.Loader.genericServiceCallWithData('/Upload.svc/rest/MultiPartUploadDocument', formData, this._finishedUploadReplace, headers, this._errorUpload.bind(this, file.name), this._failedUpload.bind(this, file.name));
                    // Call delete
                    if (this._deleteFormTemplate) {
                        let request = {
                            Name: this._deleteFormTemplate,
                            FormFields: [{ Name: "Document Handle", Value: this._replaceDocInProgress.ItemNum.toString() }]
                        };
                        this._core.Loader.genericServiceCallWithData('/Forms.svc/rest/SaveEForm', JSON.stringify(request), this._docDeleted.bind(this, this._replaceDocInProgress.ItemNum), null, this._callErrorHandler, this._callFailedHandler);
                    }
                    else {
                        this._core.Loader.genericServiceCall(`/Documents.svc/rest/DeleteDocument/${this._replaceDocInProgress.ItemNum}`, this._docDeleted.bind(this, this._replaceDocInProgress.ItemNum), this._replaceDeleteCallErrorHandler, this._replaceDeleteCallFailedHandler);
                    }
                };
                // Pull keywords from all the sources we can
                this._assembleKeywords = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._assembleKeywords()");
                    // Need some holders for all the info
                    // Anything in the keyword panel has already been filtered according to the settings so
                    // should be all valid and form the basic list for upload
                    let compiledRecords = this._kwComponent.KeywordRecords;
                    // Need a list of keywords set by the user so we can evaluate the overrides
                    let userKeywordNames = [];
                    compiledRecords.forEach(sourceRecord => {
                        sourceRecord.Keywords.forEach(sourceKey => {
                            if (userKeywordNames.indexOf(sourceKey.Name) == -1)
                                userKeywordNames.push(sourceKey.Name);
                        });
                    });
                    // Also get a list of allowed single instance/standalone keywords on the target doc type
                    let allowedKeywordNames = [];
                    this._activeDocType.KeywordRecords.forEach(sourceRecord => {
                        if ((sourceRecord.Type == "StandAlone") || (sourceRecord.Type == "SingleInstance")) {
                            sourceRecord.KeywordTypes.forEach(sourceKeyType => {
                                if (allowedKeywordNames.indexOf(sourceKeyType.Name) == -1)
                                    allowedKeywordNames.push(sourceKeyType.Name);
                            });
                        }
                    });
                    // Target and reference standalone keyword records are needed for reference
                    let targetSARecord = compiledRecords.find(rec => rec.Type == "StandAlone");
                    if (!targetSARecord) {
                        targetSARecord = { Id: 0, Name: "Standalone Keywords", Type: "StandAlone", Keywords: [] };
                        compiledRecords.push(targetSARecord);
                    }
                    let unidKeyDef = this._core.OBHelper.KeywordTypes.find(kt => kt.Name == this._uniqueIdKeywordName);
                    let keyId = unidKeyDef ? unidKeyDef.Id : 0;
                    let unidKey = { Id: keyId, Name: this._uniqueIdKeywordName, Value: this._uniqueId };
                    targetSARecord.Keywords.push(unidKey);
                    // Go through the inherited items and port them over
                    this._activeDocument.KeywordRecords.forEach(sourceRecord => {
                        if ((sourceRecord.Type == "StandAlone") || (sourceRecord.Type == "SingleInstance")) {
                            sourceRecord.Keywords.forEach(sourceKey => {
                                if (this._typedConfig.InheritKeywords.indexOf(sourceKey.Name) > -1) {
                                    if ((allowedKeywordNames.indexOf(sourceKey.Name) > -1) && ((userKeywordNames.indexOf(sourceKey.Name) == -1) || !this._allowInheritedOverride)) {
                                        targetSARecord.Keywords.push(sourceKey);
                                    }
                                }
                            });
                        }
                        else if (this._typedConfig.InheritKeywordGroups.indexOf(sourceRecord.Name) > -1) {
                            // Need to check whether the uploading doc type actually accepts this record type
                            this._activeDocType.KeywordRecords.forEach(acceptableRecord => {
                                if (acceptableRecord.Name == sourceRecord.Name)
                                    compiledRecords.push(sourceRecord);
                            });
                        }
                    });
                    if (this._activeRequirement.DocTypeName.startsWith(this._duplicateSeparator)) {
                        let keyName = this._extractDuplicateKeyName(this._activeRequirement.DocTypeName);
                        let keyValue = this._extractDuplicateKeyValue(this._activeRequirement.DocTypeName);
                        let key = { Id: 0, Name: keyName, Value: keyValue };
                        targetSARecord.Keywords.push(key);
                    }
                    return compiledRecords;
                };
                this._refreshDocumentList = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._refreshDocumentList()");
                    this._getExistingRelatedDocuments();
                };
                this._finishedUpload = (fileName, docData) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._finishedUpload()");
                    // Announce a successful upload
                    let doc = null;
                    if (docData.MultiPartUploadDocumentResult.Documents && (docData.MultiPartUploadDocumentResult.Documents.length > 0)) {
                        doc = docData.MultiPartUploadDocumentResult.Documents[0];
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_UPLOADED);
                        navEvent.ActivationID = doc.ItemNum;
                        navEvent.PrimaryContext = doc;
                        navEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                    this._filesToProcess--;
                    if (this._filesToProcess == 0) {
                        this._getExistingRelatedDocuments();
                        if (this._busyModalSession) {
                            this._core.Helper.closeBusyModal(this._busyModalSession);
                            this._busyModalSession = null;
                        }
                        if (doc && this._selectUploadedDocs) {
                            let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                            navEvent.ActivationID = doc.ItemNum;
                            navEvent.PrimaryContext = doc;
                            navEvent.Slots = this._activateIntoSlots;
                            navEvent.Layout = this._currentLayout;
                            this._core.Navigation.Details.requestActivation(navEvent);
                        }
                    }
                };
                this._finishedUploadReplace = (docData) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._finishedUploadReplace()");
                    // Announce a successful upload
                    let doc = null;
                    if (docData.MultiPartUploadDocumentResult.Documents && (docData.MultiPartUploadDocumentResult.Documents.length > 0)) {
                        doc = docData.MultiPartUploadDocumentResult.Documents[0];
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_UPLOADED);
                        navEvent.ActivationID = doc.ItemNum;
                        navEvent.PrimaryContext = doc;
                        navEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                    this._replaceUploadProcessed = true;
                    if (this._replaceDeleteProcessed) {
                        this._replaceDocInProgress = null;
                        this._getExistingRelatedDocuments();
                        if (this._busyModalSession) {
                            this._core.Helper.closeBusyModal(this._busyModalSession);
                            this._busyModalSession = null;
                        }
                        if (doc && this._selectUploadedDocs) {
                            let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                            navEvent.ActivationID = doc.ItemNum;
                            navEvent.PrimaryContext = doc;
                            navEvent.Slots = this._activateIntoSlots;
                            navEvent.Layout = this._currentLayout;
                            this._core.Navigation.Details.requestActivation(navEvent);
                        }
                    }
                    else
                        this._replaceDocInProgress = doc;
                };
                this._errorUpload = (fileName, url, status, text) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._errorUpload()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_UPLOAD_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + text;
                    this.addError(msgBody);
                    // Finalise
                    if (!this._replaceDocInProgress) {
                        this._filesToProcess--;
                        if (this._filesToProcess == 0) {
                            this._getExistingRelatedDocuments();
                            if (this._busyModalSession) {
                                this._core.Helper.closeBusyModal(this._busyModalSession);
                                this._busyModalSession = null;
                            }
                        }
                    }
                    else {
                        this._replaceUploadProcessed = true;
                        if (this._replaceDeleteProcessed) {
                            this._replaceDocInProgress = null;
                            this._getExistingRelatedDocuments();
                            if (this._busyModalSession) {
                                this._core.Helper.closeBusyModal(this._busyModalSession);
                                this._busyModalSession = null;
                            }
                        }
                    }
                };
                this._failedUpload = (fileName, docData) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._failedUpload()");
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_UPLOAD_ERROR_MSG');
                    let errorMsg = msgPrefix + ": ";
                    if (docData.hasOwnProperty('MultiPartUploadDocumentResult') && docData.MultiPartUploadDocumentResult.hasOwnProperty('Connection') && docData.MultiPartUploadDocumentResult.Connection.hasOwnProperty('Message')) {
                        errorMsg += docData.MultiPartUploadDocumentResult.Connection.Message;
                    }
                    this.addError(errorMsg);
                    // Finalise
                    if (!this._replaceDocInProgress) {
                        this._filesToProcess--;
                        if (this._filesToProcess == 0) {
                            this._getExistingRelatedDocuments();
                            if (this._busyModalSession) {
                                this._core.Helper.closeBusyModal(this._busyModalSession);
                                this._busyModalSession = null;
                            }
                        }
                    }
                    else {
                        this._replaceUploadProcessed = true;
                        if (this._replaceDeleteProcessed) {
                            this._replaceDocInProgress = null;
                            this._getExistingRelatedDocuments();
                            if (this._busyModalSession) {
                                this._core.Helper.closeBusyModal(this._busyModalSession);
                                this._busyModalSession = null;
                            }
                        }
                    }
                };
                this._documentSelected = (doc) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._documentSelected()");
                    if (!this._core.OBHelper.RequiredDocumentsEnabled) {
                        this.addError(this._core.Locale.getTranslation("STR_WPT_REQUIRED_DOCUMENTS_DISABLED"));
                        return;
                    }
                    // Clear down banners and mode
                    this._core.Functions.hideElement(this._subheader);
                    this._interfaceLocked = this._staticMode;
                    // We need a document and a unique ID
                    this._activeDocument = doc;
                    if (!doc) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("document deselected");
                        }
                        this._core.Functions.hideElement(this._mainContentDiv);
                        this._core.Functions.showElement(this._noProfileBanner);
                        this._dataList.clearList();
                        this._activeProfile = null;
                        this._uniqueId = null;
                        return;
                    }
                    this._uniqueId = this._core.OBHelper.GetKeywordValue(doc, this._uniqueIdKeywordName);
                    if (!this._uniqueId) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("document does not have unique ID set");
                        }
                        this._core.Functions.hideElement(this._mainContentDiv);
                        this._core.Functions.showElement(this._noProfileBanner);
                        this._dataList.clearList();
                        this._activeProfile = null;
                        return;
                    }
                    // Check we are servicing the expected document type
                    if ((this._typedConfig.ServiceDocumentTypes.indexOf('*') > -1) || (this._typedConfig.ServiceDocumentTypes.indexOf(doc.DocType.Name) > -1)) {
                        // Need to check for interface locking
                        if (this._lockKeywordTypeName) {
                            let lockValue = this._core.OBHelper.GetKeywordValue(doc, this._lockKeywordTypeName);
                            if (lockValue && (this._typedConfig.LockKeywordValues.indexOf(lockValue) != -1))
                                this._interfaceLocked = true;
                            else
                                this._interfaceLocked = this._staticMode;
                        }
                        if (this._interfaceLocked || (this._typedConfig.Keywords.length == 0))
                            this._core.Functions.hideElement(this._keywordsDiv);
                        else
                            this._core.Functions.showElement(this._keywordsDiv);
                        // May need to define our own query for the profiles, otherwise
                        if (this._core.OBHelper.RequiredDocumentsDynamicQuerying)
                            this._requestDocumentProfile();
                        else
                            this._core.OBHelper.LoadRequiredDocuments(this._profilesReady);
                    }
                    else {
                        // Clear down the widget
                        this._core.Functions.hideElement(this._mainContentDiv);
                        this._core.Functions.showElement(this._noProfileBanner);
                        this._activeProfile = null;
                        return;
                    }
                };
                this._profilesReady = (profile = null) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._profilesReady()");
                    let selectedProfile = (profile) ? profile : this._selectProfile();
                    if (!selectedProfile) {
                        // Clear down the widget
                        this._activeProfile = null;
                        this._core.Functions.showElement(this._noProfileBanner);
                        this._core.Functions.hideElement(this._mainContentDiv);
                    }
                    else {
                        // We want to work with a copy of the profile so we can track document counts
                        this._activeProfile = JSON.parse(JSON.stringify(selectedProfile));
                        // Note: stringify BREAKS the flat requirements list because the members become independent objects, so repopulate
                        this._activeProfile.Groups.forEach(group => {
                            group.Requirements.forEach(req => {
                                this._activeProfile.FlatRequirementMap[req.DocTypeName] = req;
                            });
                        });
                        /*
                        for (let groupName in this._activeProfile.Groups) {
                            for (let typeName in this._activeProfile.Groups[groupName].Requirements) {
                                let docTypeEntry: RequiredDocsDocTypeEntry = this._activeProfile.Groups[groupName].Requirements[typeName];
                                this._activeProfile.FlatRequirementMap[docTypeEntry.DocTypeName] = docTypeEntry;
                            }
                        }
                        */
                        this._prePresentUploadDocTypes();
                    }
                };
                this._selectProfile = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._selectProfile()");
                    let drivingType = this._activeDocument.DocType.Name;
                    if (!(drivingType in this._core.OBHelper.RequiredDocumentProfiles)) {
                        return null;
                    }
                    // Get the appropriate local array
                    let profiles = this._core.OBHelper.RequiredDocumentProfiles[drivingType];
                    if (profiles.length == 0) {
                        // This should really never happen
                        return null;
                    }
                    // We have sane input - go looking for an actual profile
                    if (this._contextKeyword) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("searching by context KW");
                        }
                        let kwContexts = this._core.OBHelper.GetAllKeywordValues(this._core.Context.PrimaryDocument, this._contextKeyword);
                        if (this._applyContexts.length > 0) {
                            // Filter kw contexts down to ones we have defined as supported
                            kwContexts = kwContexts.filter(context => this._applyContexts.indexOf(context) > -1);
                        }
                        for (let profile of profiles) {
                            for (let context of kwContexts) {
                                if (profile.Contexts.indexOf(context) > -1) {
                                    return profile;
                                } // if context found
                            } // for context string
                        } // for profile
                    }
                    else {
                        if (this._applyContexts.length == 0) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("no contexts, returning first profile");
                            }
                            return profiles[0];
                        }
                        else {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("searching against fixed contexts");
                            }
                            // We have a fixed list of supported contexts
                            for (let profile of profiles) {
                                for (let context of this._applyContexts) {
                                    if (profile.Contexts.indexOf(context) > -1) {
                                        return profile;
                                    } // if context found
                                } // for context string
                            } // for profile
                        }
                    }
                    // Nothing useful found anywhere
                    return null;
                };
                // If we need to build a specific request for a profile, under dynamic mode
                this._requestDocumentProfile = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._requestDocumentProfile()");
                    let drivingType = this._activeDocument.DocType.Name;
                    // Need to set up our list of contexts
                    let contexts = [];
                    if (this._contextKeyword) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("searching by context KW");
                        }
                        contexts = this._core.OBHelper.GetAllKeywordValues(this._core.Context.PrimaryDocument, this._contextKeyword);
                        if (this._applyContexts.length > 0) {
                            // Filter kw contexts down to ones we have defined as supported
                            contexts = contexts.filter(context => this._applyContexts.indexOf(context) > -1);
                        }
                    }
                    else
                        contexts = this._applyContexts;
                    // Now we can query for a profile
                    this._core.OBHelper.GetProfileDynamic(drivingType, contexts, this._profilesReady);
                };
                this._getExistingRelatedDocuments = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._getExistingRelatedDocuments()");
                    // Safety termination of any replace operation
                    this._replaceDocInProgress = null;
                    if (!this._activeProfile)
                        return;
                    // What have we got in the system
                    let searchDef = { Type: 'bydocumenttype', Terms: [] };
                    let request = { SearchDefinition: searchDef, SuppressKeywords: false, MaxHits: 0 };
                    searchDef.Terms.push({ Term: this._uniqueIdKeywordName, Value: this._uniqueId });
                    // Need a pseudo-hashset to ensure we are limiting document types - keys represent a hash, values are irrelevant
                    let docTypeHashSet = {};
                    for (let possiblyDuplicateName in this._activeProfile.FlatRequirementMap) {
                        docTypeHashSet[this._extractDocTypeName(possiblyDuplicateName)] = 'a';
                    }
                    // Then loop the set of keys into the query
                    for (let dtName in docTypeHashSet) {
                        searchDef.Terms.push({ Term: '>>DocumentType', Value: dtName });
                    }
                    this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(request), this._existingRelatedDocumentsReceived, {}, this._callErrorHandler, this._callFailedHandler);
                };
                this._existingRelatedDocumentsReceived = (response) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._existingRelatedDocumentsReceived()");
                    this._oldHitList = Object.getOwnPropertyNames(this._currentHitList);
                    this._oldHitListTypeMap = {};
                    this._oldHitList.forEach(handle => {
                        this._oldHitListTypeMap[handle] = this._typeMapToHandle[this._currentHitList[Number(handle)].DocType.Name];
                    });
                    this._currentHitList = {};
                    if (response.hasOwnProperty('Documents') && response.Documents.length > 0) {
                        response.Documents.forEach(doc => {
                            this._currentHitList[doc.ItemNum] = doc;
                        });
                    }
                    this._updateFromHitList();
                };
                this._docClicked = (idAndMapHandle) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._docClicked()");
                    let chunks = idAndMapHandle.split('-', 2);
                    let docId = Number(chunks[0]);
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                    navEvent.ActivationID = docId;
                    navEvent.PrimaryContext = this._currentHitList[docId];
                    navEvent.Slots = this._activateIntoSlots;
                    navEvent.Layout = this._currentLayout;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._docDeleteClicked = (id, event) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._docDeleteClicked()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("doc delete clicked for: " + id);
                    }
                    if (event) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got event");
                        }
                        event.stopPropagation(); // prevent display of document
                    }
                    if (this._confirmDeletions) {
                        this._core.Helper.presentWarningContinueModal('STR_WPT_CONFIRM_DELETE_DOC', this._docDeleteConfirmed.bind(this, id), 'STR_WPT_CONTINUE_HEADING');
                    }
                    else
                        this._docDeleteConfirmed(id);
                };
                this._docDeleteConfirmed = (idAndMapHandle) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._docDeleteConfirmed()");
                    let chunks = idAndMapHandle.split('-', 2);
                    let docId = Number(chunks[0]);
                    // We may delete using workflow to avoid having to set up user permissions
                    if (this._deleteFormTemplate) {
                        let request = {
                            Name: this._deleteFormTemplate,
                            FormFields: [{ Name: "Document Handle", Value: docId.toString() }]
                        };
                        this._core.Loader.genericServiceCallWithData('/Forms.svc/rest/SaveEForm', JSON.stringify(request), this._docDeleted.bind(this, docId), null, this._callErrorHandler, this._callFailedHandler);
                    }
                    else {
                        this._core.Loader.genericServiceCall(`/Documents.svc/rest/DeleteDocument/${docId}`, this._docDeleted.bind(this, docId), this._callErrorHandler, this._callFailedHandler);
                    }
                };
                this._docDeleted = (docId, response) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._docDeleted()");
                    // Tell everyone what we've done
                    if (this._deleteNotifications) {
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DELETED);
                        navEvent.ActivationID = docId;
                        navEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                    // Just need to refresh our document list
                    if (this._replaceDocInProgress) {
                        this._replaceDeleteProcessed = true;
                        if (this._replaceUploadProcessed) {
                            // If the upload is processed, this contains the new document
                            let doc = this._replaceDocInProgress;
                            this._replaceDocInProgress = null;
                            this._getExistingRelatedDocuments();
                            if (doc && this._selectUploadedDocs) {
                                let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                                navEvent.ActivationID = doc.ItemNum;
                                navEvent.PrimaryContext = doc;
                                navEvent.Slots = this._activateIntoSlots;
                                navEvent.Layout = this._currentLayout;
                                this._core.Navigation.Details.requestActivation(navEvent);
                            }
                            if (this._busyModalSession) {
                                this._core.Helper.closeBusyModal(this._busyModalSession);
                                this._busyModalSession = null;
                            }
                        }
                    }
                    else
                        this._getExistingRelatedDocuments();
                };
                this._docReplaceClicked = (id, event) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._docReplaceClicked()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("doc replace clicked for: " + id);
                    }
                    if (event) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got event");
                        }
                        event.stopPropagation(); // prevent display of document
                    }
                    if (this._confirmReplacements) {
                        this._core.Helper.presentWarningContinueModal('STR_WPT_CONFIRM_REPLACE_DOC', this._docReplaceButtonConfirmed.bind(this, id), 'STR_WPT_CONTINUE_HEADING');
                    }
                    else
                        this._docReplaceButtonConfirmed(id);
                };
                this._docReplaceButtonConfirmed = (idAndMapHandle) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._docReplaceButtonConfirmed()");
                    let chunks = idAndMapHandle.split('-', 2);
                    let docId = Number(chunks[0]);
                    let mapId = Number(chunks[1]);
                    this._replaceDocInProgress = this._currentHitList[docId];
                    this._replaceDeleteProcessed = false;
                    this._replaceUploadProcessed = false;
                    this._activeDocType = this._core.OBHelper.UploadDocumentTypes.find(dtRecord => dtRecord.Id == this._replaceDocInProgress.DocType.Id);
                    if (!this._activeDocType) {
                        this.addError(`Unable to find definition for doc type with ID ${this._replaceDocInProgress.DocType.Id}`);
                        return;
                    } // TODO: translation
                    this._activeRequirement = this._activeProfile.FlatRequirementMap[this._typeMapFromHandle[mapId]];
                    // Select a document or documents
                    this._fileInput.click();
                };
                this._updateFromHitList = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._updateFromHitList()");
                    if (!this._activeProfile)
                        return;
                    // Zero out our required documents tracking
                    for (let dtRowId in this._activeProfile.FlatRequirementMap) {
                        this._activeProfile.FlatRequirementMap[dtRowId].Current = 0;
                    }
                    // Run through our hit list
                    for (let handle in this._currentHitList) {
                        let doc = this._currentHitList[handle];
                        // Only do something if the doc is of a type we are tracking
                        let foundFlatMapKey = null;
                        if (doc.DocType.Name in this._activeProfile.FlatRequirementMap)
                            foundFlatMapKey = doc.DocType.Name;
                        else
                            for (let flatMapEntry in this._activeProfile.FlatRequirementMap) {
                                // Document might still be relevant
                                if (flatMapEntry.startsWith(this._duplicateSeparator)) {
                                    let keyName = this._extractDuplicateKeyName(flatMapEntry);
                                    let keyValue = this._core.OBHelper.GetKeywordValue(doc, keyName);
                                    if (keyValue == this._extractDuplicateKeyValue(flatMapEntry))
                                        foundFlatMapKey = flatMapEntry;
                                }
                            }
                        if (foundFlatMapKey) {
                            let oldIndex = this._oldHitList.indexOf(doc.ItemNum.toString(10));
                            if (oldIndex > -1) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("doc handle in old hitlist: " + doc.ItemNum);
                                }
                                // Remove the item from the list in case we are left with records for deleted items
                                this._oldHitList.splice(oldIndex, 1);
                            }
                            else {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("doc handle NOT in old hitlist: " + doc.ItemNum);
                                }
                                let itemData = {
                                    Id: `${doc.ItemNum.toString(10)}-${this._typeMapToHandle[foundFlatMapKey]}`,
                                    AdditionalClasses: [DOCUMENT_CLASS],
                                    DisplayName: (doc.Name) ? doc.Name : '-'
                                };
                                if (this._deleteDocEnabled && !this._interfaceLocked) {
                                    if (!itemData.SuffixIcons) {
                                        itemData.SuffixIcons = [];
                                    }
                                    let icon = {
                                        Classes: [DELETE_CLASS, ...this._deleteButtonStyles],
                                        Callback: this._docDeleteClicked
                                    };
                                    itemData.SuffixIcons.push(icon);
                                }
                                if (this._replaceDocEnabled && !this._interfaceLocked) {
                                    if (!itemData.SuffixIcons) {
                                        itemData.SuffixIcons = [];
                                    }
                                    let icon = {
                                        Classes: [REPLACE_CLASS, ...this._replaceButtonStyles],
                                        Callback: this._docReplaceClicked
                                    };
                                    itemData.SuffixIcons.push(icon);
                                }
                                let mapKey = this._typeMapToHandle[foundFlatMapKey];
                                let docTypeIdentifier = doc.DocType.Id.toString(10) + "-" + mapKey;
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("creating entry for doc type identifier: " + docTypeIdentifier);
                                }
                                let docType = this._findDocType(docTypeIdentifier);
                                if (!docType) {
                                    this.addError(`Unable to select list root for document type '${foundFlatMapKey}'`);
                                    return;
                                } // TODO: translation
                                docType.Items.push(itemData);
                            }
                            // Update the count for the record
                            this._activeProfile.FlatRequirementMap[foundFlatMapKey].Current++;
                        } // If doc type in list of related tracked types
                    } // For each doc in hit list
                    // If we have any more elements in the list, they represent deleted items so need to be deleted
                    this._oldHitList.forEach(handle => {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("removing document with handle: " + handle);
                        }
                        this._removeDocument(`${handle}-${this._oldHitListTypeMap[handle]}`);
                    }, this);
                    this._checkForProfileCompliance();
                };
                this._removeDocument = (docListIdentifier) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._removeDocument()");
                    let groupLength = this._currentListData.Items.length;
                    for (let g = 0; g < groupLength; g++) {
                        let group = this._currentListData.Items[g];
                        let typeLength = group.Items.length;
                        for (let t = 0; t < typeLength; t++) {
                            let docType = group.Items[t];
                            let index = docType.Items.findIndex(doc => doc.Id == docListIdentifier);
                            if (index > -1)
                                docType.Items.splice(index, 1);
                        }
                    }
                };
                this._findDocType = (docTypeId) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._findDocType()");
                    let groupLength = this._currentListData.Items.length;
                    for (let g = 0; g < groupLength; g++) {
                        let group = this._currentListData.Items[g];
                        let docType = group.Items.find(item => item.Id == docTypeId);
                        if (docType)
                            return docType;
                    }
                    return null;
                };
                this._findGroup = (groupId) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._findGroup()");
                    let group = this._currentListData.Items.find(item => item.Id == groupId);
                    return group;
                };
                this._checkForProfileCompliance = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._checkForProfileCompliance()");
                    // Sanity check
                    if (!this._activeProfile)
                        return;
                    // Overall banner control
                    let allRequirementsGood = true;
                    let uploadDocTypes = this._core.OBHelper.UploadDocumentTypes;
                    this._activeProfile.Groups.forEach(groupDef => {
                        groupDef.TotalDocs = 0;
                        let groupGoodRows = 0;
                        // Check the individual doc type rows and collect what we need
                        for (let typeName in groupDef.Requirements) {
                            let req = groupDef.Requirements[typeName];
                            groupDef.TotalDocs = groupDef.TotalDocs + req.Current;
                            req.Compliant = true;
                            if ((req.Minimum > 0) && (req.Current < req.Minimum))
                                req.Compliant = false;
                            if ((req.Maximum > 0) && (req.Current > req.Maximum))
                                req.Compliant = false;
                            let actualName = this._extractDocTypeName(req.DocTypeName);
                            let docType = uploadDocTypes.find(dt => dt.Name == actualName);
                            let mapKey = this._typeMapToHandle[req.DocTypeName];
                            let docTypeIdentifier = docType.Id.toString(10) + "-" + mapKey;
                            let docTypeEntry = this._findDocType(docTypeIdentifier);
                            if (docTypeEntry && !this._suppressCountBadges) {
                                docTypeEntry.SuffixBadge = req.Current.toString(10);
                            }
                            if (req.Compliant) {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`doctype '${req.DocTypeName}' good`);
                                    this._log.trace("setting good status for doc type identifier: " + docTypeIdentifier);
                                }
                                if (docTypeEntry && !this._suppressStatusIcons) {
                                    let icon = {
                                        Classes: [DOCTYPE_STATUS_CLASS, COMPLIANT_CLASS, ...this._compliantStyles]
                                    };
                                    docTypeEntry.PrefixIcons = [icon];
                                }
                                groupGoodRows++;
                            }
                            else {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`doctype '${req.DocTypeName}' not good`);
                                    this._log.trace("setting bad status for doc type identifier: " + docTypeIdentifier);
                                }
                                if (docTypeEntry && !this._suppressStatusIcons) {
                                    let icon = {
                                        Classes: [DOCTYPE_STATUS_CLASS, NONCOMPLIANT_CLASS, ...this._nonCompliantStyles]
                                    };
                                    docTypeEntry.PrefixIcons = [icon];
                                }
                            }
                            // Hide upload button if we have the max number of files
                            if (this._interfaceLocked || ((req.Maximum > 0) && (req.Current >= req.Maximum))) {
                                if (docTypeEntry && docTypeEntry.SuffixIcons && docTypeEntry.SuffixIcons.length > 0) {
                                    let icon = docTypeEntry.SuffixIcons.find(icon => icon.Classes.indexOf(UPLOAD_CLASS) > -1);
                                    if (icon.Classes.indexOf(WPTNamespace.HIDDEN_CLASS) == -1)
                                        icon.Classes.push(WPTNamespace.HIDDEN_CLASS);
                                }
                            }
                            else {
                                if (docTypeEntry && docTypeEntry.SuffixIcons && docTypeEntry.SuffixIcons.length > 0) {
                                    let icon = docTypeEntry.SuffixIcons.find(icon => icon.Classes.indexOf(UPLOAD_CLASS) > -1);
                                    let index = icon.Classes.indexOf(WPTNamespace.HIDDEN_CLASS);
                                    if (index > -1)
                                        icon.Classes.splice(index, 1);
                                }
                            }
                        } // for each doc type row in the document
                        // Now we need to figure if we have the right compliance setup for the group
                        let groupCompliant = true;
                        let lockUploads = false;
                        let lockBadRows = false;
                        // Raw compliance
                        if ((groupDef.MinDocs > 0) && (groupDef.TotalDocs < groupDef.MinDocs))
                            groupCompliant = false;
                        if ((groupDef.MaxDocs > 0) && (groupDef.TotalDocs > groupDef.MaxDocs))
                            groupCompliant = false;
                        if (groupGoodRows < groupDef.MinRows)
                            groupCompliant = false;
                        if ((groupDef.MaxRows > 0) && (groupGoodRows > groupDef.MaxRows))
                            groupCompliant = false;
                        // Interface locking
                        if ((groupDef.MaxDocs > 0) && (groupDef.TotalDocs >= groupDef.MaxDocs))
                            lockUploads = true;
                        if ((groupDef.MaxRows > 0) && (groupGoodRows >= groupDef.MaxRows))
                            lockBadRows = true;
                        // If we need to do some locking - loop and lock
                        for (let typeName in groupDef.Requirements) {
                            let req = groupDef.Requirements[typeName];
                            let actualName = this._extractDocTypeName(req.DocTypeName);
                            let docType = uploadDocTypes.find(dt => dt.Name == actualName);
                            let mapKey = this._typeMapToHandle[req.DocTypeName];
                            let docTypeIdentifier = docType.Id.toString(10) + "-" + mapKey;
                            let docTypeEntry = this._findDocType(docTypeIdentifier);
                            if (lockUploads || (!req.Compliant && lockBadRows)) {
                                if (docTypeEntry && docTypeEntry.SuffixIcons && docTypeEntry.SuffixIcons.length > 0) {
                                    let icon = docTypeEntry.SuffixIcons.find(icon => icon.Classes.indexOf(UPLOAD_CLASS) > -1);
                                    if (icon.Classes.indexOf(WPTNamespace.HIDDEN_CLASS) == -1)
                                        icon.Classes.push(WPTNamespace.HIDDEN_CLASS);
                                }
                            }
                            // One step further for the bad rows - mark as irrelevent
                            if (!req.Compliant && groupCompliant) {
                                if (docTypeEntry && !this._suppressStatusIcons) {
                                    let icon = {
                                        Classes: [DOCTYPE_STATUS_CLASS, IRRELEVANT_CLASS, ...this._irrelevantStyles]
                                    };
                                    docTypeEntry.PrefixIcons = [icon];
                                }
                            }
                        }
                        // Set the status on the group
                        let group = this._findGroup(groupDef.Id);
                        if (group && !this._suppressCountBadges) {
                            group.SuffixBadge = groupDef.TotalDocs.toString(10);
                        }
                        if (groupCompliant) {
                            if (group && !this._suppressStatusIcons) {
                                let icon = {
                                    Classes: [GROUP_STATUS_CLASS, COMPLIANT_CLASS, ...this._compliantStyles]
                                };
                                group.PrefixIcons = [icon];
                            }
                        }
                        else {
                            if (group && !this._suppressStatusIcons) {
                                let icon = {
                                    Classes: [GROUP_STATUS_CLASS, NONCOMPLIANT_CLASS, ...this._nonCompliantStyles]
                                };
                                group.PrefixIcons = [icon];
                            }
                        }
                        if (!groupCompliant)
                            allRequirementsGood = false;
                    }); // for each group definition
                    this._dataList.displayData(this._currentListData);
                    // Sort the master banner and any notifications necessary
                    if (this._interfaceLocked && !this._staticMode) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("processing master banner lock");
                        }
                        if (!this._suppressStatusBanner)
                            this._showLockedModeSubheader(allRequirementsGood);
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("processing master banner not locked");
                        }
                        this._core.Functions.hideElement(this._subheader);
                        if (allRequirementsGood) {
                            if (!this._suppressStatusBanner)
                                this._showReqsMetSubheader();
                            let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOC_REQUIREMENTS_MET);
                            navEvent.ActivationID = this._activeDocument.ItemNum;
                            navEvent.PrimaryContext = this._activeDocument;
                            navEvent.Layout = this._currentLayout;
                            this._log.trace("Firing requirements met message.");
                            this._core.Navigation.Details.requestActivation(navEvent);
                        }
                        else {
                            if (!this._suppressStatusBanner)
                                this._showReqsNotMetSubheader();
                            let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOC_REQUIREMENTS_NOT_MET);
                            navEvent.ActivationID = this._activeDocument.ItemNum;
                            navEvent.PrimaryContext = this._activeDocument;
                            navEvent.Layout = this._currentLayout;
                            this._log.trace("Firing requirements not met message.");
                            this._core.Navigation.Details.requestActivation(navEvent);
                        }
                    }
                };
                this._removeSubheaderClasses = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._removeSubheaderClasses()");
                    this._subheader.classList.remove(REQS_MET_CLASS, REQS_NOTMET_CLASS);
                };
                this._showLockedModeSubheader = (allRequirementsGood) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._showLockedModeSubheader()");
                    this._removeSubheaderClasses();
                    if (allRequirementsGood) {
                        this._subheader.classList.add(REQS_MET_CLASS);
                    }
                    else {
                        this._subheader.classList.add(REQS_NOTMET_CLASS);
                    }
                    this._subheaderText.innerText = this._lockedModeTranslation;
                    this._core.Functions.showElement(this._subheader);
                };
                this._showReqsMetSubheader = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._showReqsMetSubheader()");
                    this._removeSubheaderClasses();
                    this._subheader.classList.add(REQS_MET_CLASS);
                    this._subheaderText.innerText = this._reqsMetTranslation;
                    this._core.Functions.showElement(this._subheader);
                };
                this._showReqsNotMetSubheader = () => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._showReqsNotMetSubheader()");
                    this._removeSubheaderClasses();
                    this._subheader.classList.add(REQS_NOTMET_CLASS);
                    this._subheaderText.innerText = this._reqsNotMetTranslation;
                    this._core.Functions.showElement(this._subheader);
                };
                this._hasGroupInfo = (groupDef) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._hasGroupInfo()");
                    // Fastest ceck possible to ensure we need to show the info button
                    if (groupDef.Info)
                        return true;
                    for (let typeName in groupDef.Requirements) {
                        if (groupDef.Requirements[typeName].Info)
                            return true;
                    }
                    return false;
                };
                this._compileGroupInfo = (groupDef) => {
                    this._log.info("RequiredDocumentsWidgetInstanceClass._compileGroupInfo()");
                    // Go for a build strategy and a join
                    let builder = [];
                    if (groupDef.Info)
                        builder.push('<p>', this._core.Locale.getTranslation(groupDef.Info), '</p>');
                    for (let typeName in groupDef.Requirements) {
                        let req = groupDef.Requirements[typeName];
                        let dt = this._core.OBHelper.UploadDocumentTypeMap[req.DocTypeName];
                        if (req.Info) {
                            builder.push('<p><b>', this._core.OBHelper.getDocTypeAlias(dt.Name, dt.TranslatedName), '</b></p>');
                            builder.push('<p>', this._core.Locale.getTranslation(req.Info), '</p>');
                        }
                    }
                    return builder.join('');
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("RequiredDocumentsWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                this._acceptFilter = this._core.Config.getApplicationConfig().DefaultAcceptFilter;
            }
            activate(context) {
                this._log.info("RequiredDocumentsWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED:
                        let slots = this._reactToSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (slots.length > 0) {
                            // only remember slots we react to
                            this._lastReactedSlots = slots;
                            this._documentSelected(this._core.Context.PrimaryDocument);
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED:
                        let intersection = this._lastReactedSlots.filter(slot => (context.Slots.indexOf(slot) > -1));
                        if (intersection.length > 0) {
                            this._lastReactedSlots = [];
                            this._documentSelected(null);
                        }
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_UPLOADED:
                        this._refreshDocumentList();
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DELETED:
                        if (this._currentHitList) {
                            if (context.PrimaryContext in this._currentHitList)
                                this._refreshDocumentList();
                        }
                        break;
                }
            }
        }
        RequiredDocumentsWidgetInstanceClass.HtmlData = null;
        Widgets.RequiredDocumentsWidgetInstanceClass = RequiredDocumentsWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
